<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">一般概念</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">成为验证</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">职责</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">技术要求</a></p>
          <!-- <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">IP Addresses</a></p>
          <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">Fixed-Length Array</a></p>
          <p @click="activeted(7)" class="s1"><a :class="{active:flag==7}" href="#box7">Variable Length Array</a></p>
          <p @click="activeted(8)" class="s1"><a :class="{active:flag==8}" href="#box8">String</a></p> -->
          <div class="subAnchor">
            <!-- <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">33333333</a></p> -->
    
          </div>
        </div>
      </div>
      <div id="box1" class="p1">一般概念</div>
      <div class="p4">什么是验证器?</div>
      <div class="p3">Fax 基于 Tendermint ，它依赖于一组负责在区块链中提交新块的验证器。这些验证者通过广播投票参与共识协议，其中包含由每个验证者的私钥签名的加密签名。验证者在区块链中提交新块并获得收入以换取他们的工作。他们还必须通过对提案进行投票来参与治理。验证者根据他们的总权益进行加权。</div>
      <div class="p4">什么是“质押”?</div>
      <div class="p3">Fax 区块链利用公共权益证明 (PoS) 机制。每个验证者的权重由质押(fax) 和作为抵押品的代币数量决定。这些 fax 可以由验证者直接自行委托，也可以由其他fax 持有者委托给他们。</div>
      <div class="p3">create-validator 系统中的任何用户都可以通过发送交易来声明他们成为验证者的意图。从那里，他们可以成为验证人候选人。</div>
      <div class="p3">验证者的权重（即投票权）决定了他们是否是活跃的验证者。最初，只有投票权最大的前23名验证人将成为活跃验证人。</div>
      <div class="p4">什么是全节点?</div>
      <div class="p3">全节点是一个完全验证区块链交易和区块的程序。它与只处理块头和一小部分交易的轻节点不同。运行全节点比轻节点需要更多资源，但对于成为验证者来说是必要的。在实践中，运行全节点仅意味着运行具有低网络延迟和无停机时间的软件的最新版本。</div>
      <div class="p3">当然，即使用户不打算成为验证者，也可以并鼓励他们运行全节点。</div>
      <div id="box2" class="p2">成为验证</div>
      <div class="p4">如何成为验证者?</div>
      <div class="p3">网络中的任何参与者都可以通过发送交易来表明他们愿意成为验证者create-validator，他们必须填写以下参数：</div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>验证者 PubKey：与此 Tendermint 关联的私钥 PubKey 用于签署预投票和预提交。</li>
            <li>Validator's Address：应用层地址。这是用于公开识别您的验证者的地址。与该地址关联的私钥用于委托、解绑、领取奖励和参与治理。</li>
            <li>验证者的名字（绰号）</li>
            <li>验证者的网站（可选）</li>
            <li>验证者的描述（可选）</li>
        </ul>
      </div>
      <div class="p3">创建验证者后，fax 持有者可以将 fax 委托给他们，从而有效地将权益添加到他们的池中。一个地址的总权益是委托人绑定的 fax 和指定自己的实体自绑定的fax 的组合。在所有发出信号的验证人候选人中，质押最高的 23 人被指定为验证人。如果验证者的总权益低于前 23 名，则该验证者将失去验证者特权：因此他们无法再参与共识并产生奖励。</div>
      <div class="p4">有哪些不同类型的键？</div>
      <div class="p3">简而言之，有两种类型的键：</div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>Tendermint 密钥：这是用于签署共识投票的唯一密钥。</li>
        </ul>
      </div>
      <div class="p3">
        <ul style="padding-left:55px">
            <li>它 与 公 钥 相 关 联 fvalconspub （ 使 用获取此值）exchaind tendermint show-validator</li>
            <li>它是在使用 exchaind init 创建节点时生成的。</li>
        </ul>
      </div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>应用程序密钥：此密钥由交易创建 exchaincli 并用于签署交易。应用程序密钥与前缀为 的公钥 fpub 和前缀为 f 的地址相关联。两者都是从exchaincli keys add生成的帐户密钥派生而来</li>
        </ul>
      </div>
      <div class="p3">注意：验证器的操作员密钥直接与应用程序密钥相关联，但仅出于此目的使用保留前缀：fvaloper 和 fvaloperpub.</div>
      <div class="p4">验证者可以处于哪些不同的状态？</div>
      <div class="p3">在使用事务创建验证器后 create-validator，它们可以处于三种状态：</div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>Bonded：验证者处于活跃状态并参与共识。验证者正在获得奖励，并且可能会在行为不端的情况下被削减。</li>
            <li>jailed：验证者行为不端并被监禁，即被暂停。如果监禁是由于离线时间过长造成的，验证者可以发送 unjail 交易以重新获得他的验证者全部权利。如果监禁是由于双重签名造成的，则验证者不能自己解除监禁。</li>
            <li>unbonded：验证者不活跃，因此无法签署区块。验证人不能被削减，不会获得区块扣除社区 2%奖励后 20%平均分配的奖励，但可以获得扣除社区2%奖励后 80%按股份分配奖励。仍然可以将 fax 委托给该验证者。unbonded 立即取消对验证者的委托。</li>
        </ul>
      </div>
      <div class="p4">是否必须委派最少数量的 fax 才能成为活跃（绑定）验证者？</div>
      <div class="p3">最少质押 1000 fax 才能成为活跃（绑定）验证者获取出块资格，质押大于等于500fax，小于1000fax 没有出块资格属于 unbonded 状态验证人，质押小于 500fax 不能成为验证人。</div>
      <div class="p4">委托人将如何选择他们的验证人？</div>
      <div class="p3">委托人可以根据自己的主观标准自由选择验证人。我们认为重要的一些标准是：</div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>委托fax数量：委托给验证者的 fax 总数。高投票权表明社区信任这个验证者，但这也意味着这个验证者可能是黑客更大的目标。更大的验证者也会减少网络的去中心化。</li>
            <li>跟踪记录：委托人可能会查看他们计划委托给的验证者的跟踪记录。这包括资历、过去对提案的投票、历史平均正常运行时间以及节点可能被入侵的频率。</li>
        </ul>
      </div>
      <div class="p3">除了这些标准之外，验证者还可以添加一个网站地址来完成和增强他们的简历。验证者需要以一种或另一种方式建立声誉以吸引委托人。例如，验证者最好让第三方审核他们的设置。但请注意，Fax 团队不会自行批准或进行任何审计。</div>
      <div id="box3" class="p2">职责</div>
      <div class="p4">验证者是否需要公开身份？</div>
      <div class="p3">不，他们没有。每个委托人将根据自己的标准评估验证人。验证者在提名自己时将能够注册一个网站地址，以便他们可以在他们认为合适的时候宣传他们的操作。一些委托人可能更喜欢一个清楚地显示运营验证器的团队及其简历的网站，而其他人可能更喜欢具有积极记录的匿名验证器。</div>
      <div class="p4">验证者的职责是什么？</div>
      <div class="p3">验证者有两个主要职责：</div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>能够持续运行正确版本的软件：验证者需要确保他们的服务器始终在线并且他们的私钥不被泄露。</li>
            <li>积极参与治理：验证者需要对每个提案进行投票。</li>
        </ul>
      </div>
      <div class="p3">此外，验证者应该是社区的活跃成员。他们应该始终与生态系统的当前状态保持同步，以便他们可以轻松适应任何变化。</div>
      <div class="p4">“参与治理”意味着什么？</div>
      <div class="p3">Fax 上的验证人和委托人可以对更改操作参数（例如区块气体限制）、协调升级或对任何给定事项做出决定的提案进行投票。</div>
      <div class="p3">验证者在治理系统中扮演着特殊的角色。例如，他们需要对每一个特别重要的提案进行投票，因为不投票的委托人将继承其验证人的投票。</div>
      <div class="p4">质押意味着什么？</div>
      <div class="p3">可以将质押 fax 视为验证活动的保证金。当验证人或委托人想要取回他们的部分或全部存款时，他们会发送一笔 unbonding 交易。然后，fax 将经历 3 周的解绑期，在此期间，它们可能会因验证者在解绑过程开始之前犯下的潜在不当行为而受到惩罚。</div>
      <div class="p3">验证者和协会委托人获得区块奖励、费用，并有权参与治理。</div>
      <div class="p4">验证者能否带着委托人的 fax 逃跑？</div>
      <div class="p3">通过委托给验证者，用户委托投票权。验证者拥有的投票权越多，他们在共识和治理过程中的权重就越大。这并不意味着验证者拥有委托人的 fax 的保管权。验证者绝不可能带着委托人的资金逃跑。</div>
      <div class="p3">即使委托的资金不能被他们的验证人窃取，如果他们的验证人行为不端，委托人仍然要承担责任。</div>
      <div class="p4">多久会选择一个验证者来提议下一个区块？它会随着绑定 fax 的数量而增加吗？</div>
      <div class="p3">被选中提议下一个区块的验证者称为提议者。每个提议者都是确定性地选择的，被选择的频率与验证者的投票权（即绑定的 fax 数量）成正比。例如，如果所有验证者的总抵押权益为100 个fax，而验证者的总权益为 10 个 fax，则该验证者将提议约 10% 的块。</div>
      <div id="box4" class="p2">技术要求</div>
      <div class="p4">硬件要求是什么？</div>
      <div class="p3">验证者应该期望为一个或多个数据中心位置提供冗余电源、网络、防火墙、HSM 和服务器。</div>
      <div class="p3">我们预计最初将需要适度水平的硬件规格，并且随着网络使用的增加，它们可能会增加。参与测试网是了解更多信息的最佳方式。</div>
      <div class="p4">什么是软件要求？</div>
      <div class="p3">除了运行 Fax 节点外，验证者还应开发监控、警报和管理解决方案。</div>
      <div class="p4">什么是带宽要求？</div>
      <div class="p3">与以太坊或比特币相比，Fax 网络具有非常高的吞吐量。</div>
      <div class="p3">我们建议数据中心节点只连接到云中受信任的完整节点或其他社交上相互认识的验证者。这减轻了数据中心节点减轻拒绝服务攻击的负担。</div>
      <div class="p3">最终，随着网络的使用越来越频繁，每天数 GB 的带宽是非常现实的。</div>
      <div class="p3">运行验证器在物流方面意味着什么？</div>
      <div class="p3">成功的验证器操作将需要多个高技能人员的努力和持续的操作关注。例如，这将比运行比特币矿工涉及更多。</div>
      <div class="p4">如何处理密钥管理？</div>
      <div class="p3">验证者应该期望运行支持 ed25519 密钥的 HSM。以下是潜在的选择：</div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>YubiHSM 2</li>
            <li>Ledger Nano S</li>
            <li>Ledger BOLOS SGX enclave</li>
            <li>Thales nShield support</li>
        </ul>
      </div>
      <div class="p3">Fax 团队不推荐一种解决方案高于另一种解决方案。鼓励社区加强改进 HSM 和密钥管理安全性的努力。</div>
      <div class="p4">验证者在操作方面可以期待什么？</div>
      <div class="p3">运行有效的操作是避免意外解除绑定或被削减的关键。这包括能够响应攻击、中断以及维护数据中心的安全性和隔离性。</div>
      <div class="p4">维护要求是什么？</div>
      <div class="p3">验证者应该期望执行定期软件更新以适应升级和错误修复。网络在其引导阶段的早期不可避免地会出现问题，需要高度警惕。</div>
      <div class="p4">验证者如何保护自己免受拒绝服务攻击？</div>
      <div class="p3">当攻击者将大量 Internet 流量发送到 IP 地址以阻止 IP 地址处的服务器连接到Internet 时，就会发生拒绝服务攻击。</div>
      <div class="p3">攻击者扫描网络，试图了解各种验证节点的 IP 地址，并通过大量流量使它们与通信断开连接。</div>
      <div class="p3">减轻这些风险的一种推荐方法是让验证者在所谓的哨兵节点架构中仔细构建其网络拓扑。</div>
      <div class="p3">验证器节点应该只连接到他们信任的完整节点，因为它们自己操作它们或由他们在社交上认识的其他验证器运行。验证器节点通常会在数据中心运行。大多数数据中心提供与主要云提供商网络的直接链接。验证者可以使用这些链接连接到云中的哨兵节点。这将拒绝服务的负担从验证者的节点直接转移到其哨兵节点，并且可能需要启动或激活新的哨兵节点以减轻对现有节点的攻击。</div>
      <div class="p3">Sentry 节点可以快速启动或更改其 IP 地址。由于到哨兵节点的链接位于私有IP 空间中，因此基于 Internet 的攻击无法直接干扰它们。这将确保验证者区块提案和投票始终能够传递到网络的其余部分。</div>
      <div class="p3">预计验证者那部分的良好操作程序将完全减轻这些威胁。</div>
      
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">一般概念</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">成为验证</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">职责</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">技术要求</a></p>
      <!-- <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">IP Addresses</a></p>
      <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">Fixed-Length Array</a></p>
      <p @click="activeted(7)" class="s1"><a :class="{active:flag==7}" href="#box7">Variable Length Array</a></p>
      <p @click="activeted(8)" class="s1"><a :class="{active:flag==8}" href="#box8">String</a></p> -->
      <div class="subAnchor">
        <!-- <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">33333333</a></p> -->

      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SerializationPrimitives',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>